import axios from "axios"
import { create } from "zustand"

export let usePostCat = create((set, get) => ({
    cats: [],
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
        },
        {
            title: "Nomi",
            dataIndex: "name",
            key: "name",
        },
    ],
    ed: {},
    setEd: (ed) => set({ ed }),
    setCats: () => {
        axios.get('/post-categories')
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ cats: data });
            })
            .catch((err) => {
                console.error('Maqola kategoriyalarini yuklab olishda xatolik:', err);
                set({ cats: [] });
            })
    },
    addCat: (cat) => {
        axios.post('/post-categories', cat)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Maqola kategoriyasi qo\'shishda xatolik:', err);
            })
    },
    editCat: (cat) => {
        axios.put('/post-categories/' + cat.id, cat)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Maqola kategoriyasini taxrirlashda xatolik:', err);
            })
    },
    delCat: (id) => {
        axios.delete('/post-categories/' + id)
            .then((res) => {
                get().setCats();
            })
            .catch((err) => {
                console.error('Maqola kategoriyasini o\'chirishda xatolik:', err);
            })
    }
}))